// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3b1346dd","453":"e0b072e8"}[chunkId] + ".chunk.js";
};